// import React from 'react';
// import { useLocation } from 'react-router-dom';
// import Header from "../../src/Components/Header/Navbar";
// import Footer from "../../src/Components/Footer/Footer";

// const Layout = ({ children }) => {
//     const location = useLocation();
    
//     // Add routes where header and footer should be hidden
//     const hideHeaderFooterRoutes = [
//       '/admin',
//       // Add more routes here if needed
//       // '/another-admin-route',
//       // '/dashboard'
//     ];
  
//     const shouldShowHeaderFooter = !hideHeaderFooterRoutes.includes(location.pathname);
  
//     return (
//       <>
//         {shouldShowHeaderFooter && <Header />}
//         {children}
//         {shouldShowHeaderFooter && <Footer />}
//       </>
//     );
//   };
  
//   export default Layout

import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from "../../src/Components/Header/Navbar";
import Footer from "../../src/Components/Footer/Footer";

const Layout = ({ children }) => {
  const location = useLocation();

  // Routes where both Header and Footer are hidden
  const hideHeaderFooterRoutes = ['/admin'];

  // Routes where only the Footer should be hidden
  const hideFooterOnlyRoutes = ['/shop'];

  // Determine visibility for Header and Footer
  const shouldShowHeader = !hideHeaderFooterRoutes.includes(location.pathname);
  const shouldShowFooter =
    !hideHeaderFooterRoutes.includes(location.pathname) &&
    !hideFooterOnlyRoutes.includes(location.pathname);

  return (
    <>
      {shouldShowHeader && <Header />}
      {children}
      {shouldShowFooter && <Footer />}
    </>
  );
};

export default Layout;
